import React from 'react';

const Icon = ({ type, color, size }: Props) => {
  return (
    <div className={`avatar flex-shrink-0 ${size ? 'avatar-' + size : ''}`}>
      <span className={`avatar-initial rounded ${color}`}>
        <i className={`ti ti-${type} ti-${size ||'md'}`}></i>
      </span>
    </div>
  );
}

interface Props {
  type: string,
  color: string,
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { Icon };